import axios from 'axios';
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { url } from '../utils/confserveur';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Données utilisateur
  const [isAuthenticated, setIsAuthenticated] = useState(false); // Authentification
  const [loading, setLoading] = useState(false); // Chargement initial
  const [etablissementLoading, setEtablissementLoading] = useState(false); // ✅ NOUVEAU : État de chargement pour établissement
  
  const [etablissementError, setEtablissementError] = useState(false);
  const [etablissementData, setEtablissementData] = useState(null); // Stockage des établissements
   const [matiereFilter, setMatiereFilter] = useState(null); // null par défaut, seul le chef d'établissement utilisera ce filtre
   const [syncEleve, setSyncEleve] = useState(false);
  const [ resultatsFilter, setResultatsFilter] = useState("combinés");
     //State pour gérer les professeurs ayant plusieurs établissements d'affectation.
      const [selectedEtablissementId ,setSelectedEtablissementId] = useState(null)
  const init = () => {
    setUser(null)
    setIsAuthenticated(false)
    setLoading(false)
    setEtablissementLoading(false)
    setEtablissementError(false)
    setEtablissementData(null)
    setSelectedEtablissementId(null)
    setSyncEleve(false)
  }


  const fetchUserData = async () => {
 
    try {
      setLoading(true)
      const response = await axios.get(url + 'api/check-authenticated/', {
        withCredentials: true,
      });
              const userData = response.data.user;
        setUser(userData);
       
        // Déterminer l'ID de l'établissement avec le bon ordre de priorité
        let etabId = null;
        
        // 1️⃣ PRIORITÉ ABSOLUE : Connexion GAR (session backend)
        if (userData.current_etablissement_id) {
            etabId = userData.current_etablissement_id;
           
        }
        // 2️⃣ Si le professeur a UN SEUL établissement (pas de GAR)
        else if (Array.isArray(userData.etablissements) && userData.etablissements.length === 1) {
            etabId = userData.etablissements[0].id;
           
        }
        // 3️⃣ Si l'utilisateur a un etablissement_id direct (chef, élève)
        else if (userData.etablissement_id) {
            etabId = userData.etablissement_id;
            
        }
        // 4️⃣ DERNIER RECOURS : localStorage (risqué)
        else if (localStorage.getItem('etablissement_id')) {
            etabId = parseInt(localStorage.getItem('etablissement_id'), 10);
            
        }
        
        // Définir l'établissement sélectionné
        if (etabId) {
            setSelectedEtablissementId(etabId);

        } else {
            console.warn("❌ Aucun établissement ID trouvé!");
        }

        // Si l'utilisateur est un chef d'établissement, définir matiereFilter à "maths" par défaut
        if (userData.role === "chef") {
            setMatiereFilter("maths");
        }

      setIsAuthenticated(true);
     
      return true; // Retourne true si l'utilisateur est authentifié
    } catch (error) {
      setIsAuthenticated(false);
      setUser(null);
      return false; // Retourne false si l'utilisateur n'est pas authentifié
    } finally {
      setLoading(false);
    }
  };


   const fetchEtablissementData = useCallback(async (reload) => {
  // Ajouter !etablissementLoading pour éviter les appels dupliqués pendant le chargement
  if (isAuthenticated && (!etablissementData || reload) && user && selectedEtablissementId && !etablissementLoading) {
    try {
      setEtablissementLoading(true); // ✅ Début du chargement
      setEtablissementError(false); // Reset l'erreur
    
      const response = await axios.get(`${url}etablissements/by-user/?user_id=${user.id_user}&etablissement_id=${selectedEtablissementId}`, {
        withCredentials: true,
      });
      
      setEtablissementData(response.data); // Stocker les données des établissements
   
    } catch (error) {
      console.error("Erreur lors de la récupération des établissements :", error);
       setEtablissementError(true); // Marquer l'erreur
    } finally {
      setEtablissementLoading(false); // ✅ Fin du chargement (succès ou erreur)
    }
  }
}, [isAuthenticated, etablissementData, user, selectedEtablissementId, etablissementLoading]);
  
 
 

  const refreshEtablissementData = async () => {
    await fetchEtablissementData(true);
  };

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        isAuthenticated,
        setIsAuthenticated,
        fetchUserData,
        fetchEtablissementData,
        loading,
        etablissementLoading,
        etablissementError,
        init,
        etablissementData,
        setEtablissementData,
        refreshEtablissementData,
        matiereFilter,
        setMatiereFilter,
        syncEleve,
        setSyncEleve,
        resultatsFilter,
        setResultatsFilter,
        selectedEtablissementId,
        setSelectedEtablissementId,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);